import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaIcon } from '../FaIcon';
import { SupportChatService } from '../support_chat/SupportChatService';

export function DashboMCPUpgrade() {
    const { t } = useTranslation();

    const handleUpgradeClick = (e) => {
        e.preventDefault();
        const message = t('dashbo_mcp.upgrade.intercom_message');
        SupportChatService.showNewMessage(message);
    };

    const benefits = [
        {
            icon: 'layer-group',
            title: t('dashbo_mcp.upgrade.benefit_1_title'),
            desc: t('dashbo_mcp.upgrade.benefit_1_desc'),
        },
        {
            icon: 'comments',
            title: t('dashbo_mcp.upgrade.benefit_2_title'),
            desc: t('dashbo_mcp.upgrade.benefit_2_desc'),
        },
        {
            icon: 'bolt',
            title: t('dashbo_mcp.upgrade.benefit_3_title'),
            desc: t('dashbo_mcp.upgrade.benefit_3_desc'),
        },
        {
            icon: 'robot',
            title: t('dashbo_mcp.upgrade.benefit_4_title'),
            desc: t('dashbo_mcp.upgrade.benefit_4_desc'),
        },
    ];

    return (
        <div className="upgrade-to-dashbo-page dbc-upgrade-page">
            <div className="upgrade-hero">
                <div className="upgrade-hero-badge">
                    <span className="icon"><FaIcon iconName="crown"/></span>
                    {t('dashbo_mcp.upgrade.plan_badge')}
                </div>
                <div className="dbc-upgrade-main-icon">
                    <FaIcon iconName="microchip"/>
                </div>
                <h1 className="upgrade-hero-title">{t('dashbo_mcp.upgrade.title')}</h1>
                <p className="upgrade-hero-subtitle">{t('dashbo_mcp.upgrade.subtitle')}</p>
                <button
                    type="button"
                    className="btn -alt upgrade-hero-cta"
                    onClick={handleUpgradeClick}
                >
                    {t('dashbo_mcp.upgrade.cta')}
                </button>
            </div>

            <div className="upgrade-benefits">
                <div className="benefits-grid">
                    {benefits.map((b, i) => (
                        <div key={i} className="benefit-card">
                            <div className="benefit-card-icon">
                                <span className="icon"><FaIcon iconName={b.icon}/></span>
                            </div>
                            <h3>{b.title}</h3>
                            <p>{b.desc}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="dbc-upgrade-footer">
                <p className="dbc-upgrade-support">{t('dashbo_mcp.upgrade.support')}</p>
                <button
                    type="button"
                    className="btn -alt"
                    onClick={handleUpgradeClick}
                >
                    {t('dashbo_mcp.upgrade.cta')}
                </button>
            </div>
        </div>
    );
}
